"use client";

import { Accordion } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import React, { useEffect, useState } from "react";
import { RemoveScroll } from "react-remove-scroll";
import { breakpoints } from "../../helpers/window";
import { useWindowSize } from "../../hooks/useWindowSize";
import { useCoveoContext } from "../../providers/CoveoProvider";
import { usePublicConfigContext } from "../../providers/PublicConfigProvider";
import { useTranslations } from "../../helpers/translations";
import GlobalSearchStandalone from "./global-search/GlobalSearchStandalone";
import { MobileSubMenu } from "./shared/MobileSubMenu";
import { CompanySubMenu } from "./subnav/CompanySubMenu";
import { PlatformSubMenu } from "./subnav/PlatformSubMenu";
import { ResourcesSubMenu } from "./subnav/ResourcesSubMenu";
import { ShopSubMenu } from "./subnav/ShopSubMenu";
import { SolutionsSubMenu } from "./subnav/SolutionsSubMenu";
import { RegionLocaleSelector } from "./utility-links/user-menu/RegionLocaleSelector";

export const MobileNavigation = () => {
  const [opened, setOpened] = useState(false);
  const { width } = useWindowSize();

  const t = useTranslations("nav");

  const { COVEO_ORGANIZATION_ID } = usePublicConfigContext();
  const { jwtCreateGlobalSearch, jwtRenewGlobalSearch } = useCoveoContext();

  const toggleMenu = () => {
    setOpened((opened) => !opened);
  };

  const globalSearchAccessToken =
    jwtCreateGlobalSearch.data?.coveoJwtCreate.jwt;

  const closeMobileMenu = () => setOpened(false);

  useEffect(() => {
    if (width && width >= breakpoints.lg) {
      setOpened(false);
    }
  }, [width, setOpened]);

  return (
    <>
      <button
        className="appearance-none bg-transparent border-none ml-lg px-md py-lg group"
        onClick={() => toggleMenu()}
      >
        <div
          className={cn(`tham tham-e-squeeze tham-w-6 hover:opacity-100`, {
            "tham-active": opened,
          })}
        >
          <div className="tham-box">
            <div className="tham-inner bg-gray-400" />
          </div>
        </div>
      </button>
      {opened && (
        <RemoveScroll>
          <div
            className={cn(
              "fixed left-0 bottom-0 right-0 top-[var(--header-nav-height)] w-full z-50 h-[calc(100dvh-var(--header-nav-height))] p-xl bg-utility-gray-800 overflow-y-scroll overflow-x-hidden",
            )}
          >
            <div className="flex flex-col gap-xl">
              {COVEO_ORGANIZATION_ID && globalSearchAccessToken && (
                <GlobalSearchStandalone
                  accessToken={globalSearchAccessToken}
                  organizationId={COVEO_ORGANIZATION_ID}
                  variant="inline"
                  jwtRenewGlobalSearch={jwtRenewGlobalSearch}
                  placeholder={t("search.placeholder")}
                  inputClassName="border-primary border"
                  beforeSearchSubmit={closeMobileMenu}
                />
              )}
              <div className="flex flex-wrap gap-md">
                <Button
                  asChild
                  variant="secondaryGray"
                  size="xl"
                  className="dark grow shrink-0 no-underline hover:no-underline"
                >
                  <a href={t("video_call.href")}>{t("video_call.text")}</a>
                </Button>
                <Button
                  asChild
                  variant="default"
                  size="xl"
                  className="dark grow shrink-0 no-underline hover:no-underline"
                >
                  <a href={t("design_now.href")}>{t("design_now.text")}</a>
                </Button>
              </div>
              <Accordion type="multiple" className="w-full border-0">
                <PlatformSubMenu
                  key="platform"
                  wrapperComponent={MobileSubMenu}
                  compact={true}
                />
                <SolutionsSubMenu
                  key="applications"
                  wrapperComponent={MobileSubMenu}
                  compact={true}
                />
                <ShopSubMenu
                  key="shop"
                  wrapperComponent={MobileSubMenu}
                  compact={true}
                />
                <ResourcesSubMenu
                  key="resources"
                  wrapperComponent={MobileSubMenu}
                  compact={true}
                />
                <CompanySubMenu
                  key="community"
                  wrapperComponent={MobileSubMenu}
                  compact={true}
                />
              </Accordion>
              <div className="py-4xl px-xl space-y-xl">
                <RegionLocaleSelector labelClassName="text-sm-semibold text-white" />
              </div>
            </div>
          </div>
        </RemoveScroll>
      )}
    </>
  );
};
